import { Trophy } from '@phosphor-icons/react';

import styles from './QuizScore.module.css';

interface QuizScoreProps {
    score: number;
    total: number;
}

export function QuizScore({ score, total }: QuizScoreProps) {
    const percentage = total > 0 ? Math.round((score / total) * 100) : 0;

    const getGrade = () => {
        if (percentage >= 90) return { label: 'Excelente', className: styles.gradeA };
        if (percentage >= 70) return { label: 'Bien', className: styles.gradeB };
        if (percentage >= 50) return { label: 'Regular', className: styles.gradeC };
        return { label: 'Necesita mejorar', className: styles.gradeD };
    };

    const { label, className } = getGrade();

    return (
        <div className={styles.card}>
            <Trophy size={40} weight="fill" className={`${styles.icon} ${className}`} />
            <h3 className={styles.title}>Tu resultado</h3>
            <p className={`${styles.score} ${className}`}>
                {score} / {total} puntos
            </p>
            <p className={styles.percentage}>{percentage}%</p>
            <span className={`${styles.grade} ${className}`}>{label}</span>
        </div>
    );
}
